import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@material-ui/core';

const NewDriveIcon: FunctionComponent = () => {
  return (
    <SvgIcon
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: '20px', width: '20px', fill: 'none' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49 24.5C49 38.031 38.031 49 24.5 49C10.969 49 0 38.031 0 24.5C0 10.969 10.969 0 24.5 0C38.031 0 49 10.969 49 24.5ZM21 42.6694V34.5022C20.6 30.1022 15.8333 28.0022 13.5 27.5022H6.24237C7.49007 35.1479 13.4244 41.2188 21 42.6694ZM6.24164 21.5022H11C21.9803 15.4092 27.9367 15.59 38.25 21.5022H42.7584C41.3259 12.7106 33.6966 6 24.5 6C15.3034 6 7.67412 12.7106 6.24164 21.5022ZM42.7576 27.5022C41.4555 35.4813 35.0492 41.7452 27 42.8325V34.5022C27.6667 32.1689 30.2 27.5022 35 27.5022H42.7576Z"
        fill="#1C69D4"
      />
    </SvgIcon>
  );
};

export default NewDriveIcon;
